module.exports = __webpack_public_path__ + "img/mercurialeComparative.938180ff.png";